import { Fragment } from 'react';

const ReactNativeAnimatedDotsCarousel = Fragment;
export default ReactNativeAnimatedDotsCarousel;
